import { render, staticRenderFns } from "./Calificaciones.vue?vue&type=template&id=29bf817c&"
import script from "./Calificaciones.vue?vue&type=script&lang=js&"
export * from "./Calificaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports